import React from "react";
import { Countdown } from "@caelor/ui";

import Textarea from "../../inline-edit/EditableText";
import Input from "../../inline-edit/EditableLine";

import getReadableColor from "../../../../../components/ui/color-picker/getReadableColor";
import { urlValidator } from "../../../../../helpers/validators";
import { TitleContainer } from "./styles";

const ELEMENT_KEYS = {
  text: "description",
  label: "linkText",
  arrow: "arrow",
};

const handleOnClick = (url, newTab, mode) => {
  const isValid = urlValidator({ url, protocols: ["https:"] });

  if (mode === "view" && isValid) {
    window.open(url, newTab ? "_blank" : "_top");
  }
};

const Background = ({ data, isEditable, viewMode = "view" }) => (
  <Countdown
    dateandtime={Number(String(new Date(data.time).getTime()).slice(0, 10))}
    activeElements={data.timerLayout.map(({ value }) => ELEMENT_KEYS[value])}
    view="image"
    link={data.url}
    hasBorder
    image={data.image}
    isEditing={isEditable}
    openInNewTab={data.newTab}
    borderRadius={`${data.borderRadius}px`}
    onClick={({ link }) => handleOnClick(link, data.newTab, viewMode)}
    title={
      <TitleContainer>
        <Textarea value={data.title} propKey="title" isEditable={isEditable} />
      </TitleContainer>
    }
    linkText={
      <Input value={data.linkText} propKey="linkText" isEditable={isEditable} />
    }
    description={
      <Textarea value={data.text} propKey="text" isEditable={isEditable} />
    }
    color={{
      accent: data.colorFields.Timer,
      text: {
        light: getReadableColor(data.colorFields.Timer.light),
        dark: getReadableColor(data.colorFields.Timer.dark),
      },
    }}
  />
);

export default Background;
